import { defineStore } from "pinia";
import { messagingSocketService, } from "@/services/messagingSocketService";
export const useTransportRealtimeStore = defineStore("transportRealtime", {
    state: () => ({
        initialized: false,
        locationsByTripId: {},
        passengerOverrides: {},
        completedTripIds: [],
        unsubscribe: null,
    }),
    getters: {
        locationForTrip: (state) => (tripId) => state.locationsByTripId[tripId] ?? null,
        passengerStatus: (state) => (tripId, passengerKey) => state.passengerOverrides[`${tripId}#${passengerKey}`]?.status,
        isTripCompleted: (state) => (tripId) => state.completedTripIds.includes(tripId),
    },
    actions: {
        init() {
            if (this.initialized)
                return;
            this.unsubscribe = messagingSocketService.addEventListener((event) => this.handleEvent(event));
            this.initialized = true;
        },
        dispose() {
            if (this.unsubscribe) {
                this.unsubscribe();
                this.unsubscribe = null;
            }
            this.initialized = false;
        },
        clearTripState(tripId) {
            const nextLocations = { ...this.locationsByTripId };
            delete nextLocations[tripId];
            this.locationsByTripId = nextLocations;
            this.passengerOverrides = Object.fromEntries(Object.entries(this.passengerOverrides).filter(([key]) => !key.startsWith(`${tripId}#`)));
        },
        handleEvent(event) {
            const type = String(event.type || "");
            if (!type.startsWith("transport."))
                return;
            if (type === "transport.trip.location") {
                const tripId = String(event.tripId || "");
                const location = event.location;
                if (!tripId || !location)
                    return;
                this.locationsByTripId = {
                    ...this.locationsByTripId,
                    [tripId]: location,
                };
                return;
            }
            if (type === "transport.trip.passenger.boarded") {
                const tripId = String(event.tripId || "");
                const passengerKey = String(event.passengerKey || "");
                if (!tripId || !passengerKey)
                    return;
                const key = `${tripId}#${passengerKey}`;
                this.passengerOverrides = {
                    ...this.passengerOverrides,
                    [key]: {
                        tripId,
                        passengerKey,
                        status: String(event.status || "BOARDED"),
                        boardedAt: event.boardedAt
                            ? String(event.boardedAt)
                            : undefined,
                        updatedAt: new Date().toISOString(),
                    },
                };
                return;
            }
            if (type === "transport.trip.completed") {
                const tripId = String(event.tripId || "");
                if (!tripId)
                    return;
                if (!this.completedTripIds.includes(tripId)) {
                    this.completedTripIds = [...this.completedTripIds, tripId];
                }
                this.clearTripState(tripId);
            }
        },
    },
});
